<template>
  <b-list-group>
    <b-list-group-item>
      <div class="font-weight-bold text-primary">
        Adı Soyad
      </div>
      <div>{{ dataItem.name? dataItem.name : '-' }}</div>
    </b-list-group-item>
    <b-list-group-item>
      <div class="font-weight-bold text-primary">
        E-Posta
      </div>
      <div>{{ dataItem.email? dataItem.email : '-' }}</div>
    </b-list-group-item>
    <b-list-group-item>
      <div class="font-weight-bold text-primary">
        Telefon
      </div>
      <div>{{ dataItem.phone? dataItem.phone : '-' }}</div>
    </b-list-group-item>
    <b-list-group-item>
      <div class="font-weight-bold text-primary">
        Mesaj
      </div>
      <div>{{ dataItem.message? dataItem.message : '-' }}</div>
    </b-list-group-item>
    <b-list-group-item>
      <div class="font-small-2 text-muted">
        {{ moment(dataItem.created).format('llll') }} tarihinde {{ dataItem.ip_address? dataItem.ip_address : '-' }} ip adresinden gönderildi.
      </div>
    </b-list-group-item>
  </b-list-group>
</template>
<script>
import { BListGroup, BListGroupItem } from 'bootstrap-vue'

export default {
  name: 'InfoCard',
  components: { BListGroup, BListGroupItem },
  props: {
    dataItem: {
      type: Object,
      required: true,
    },
  },
}
</script>
